import Sidebar from './pages/Sidebar';
import { Outlet } from 'react-router-dom';

export default function MainLayout() {
  return (
    <div className="flex relative w-full h-full items-start">
      <Sidebar />
      <div className="overflow-auto py-6 px-6 max-h-full min-h-screen grid w-full [scrollbar-gutter:stable]">
        <Outlet />
      </div>
    </div>
  );
}
